import appConfigData from '@fe/zxwy-utils/appConfig'
import { validate } from '@fe/zxwy-utils/utils/typename'

export const appConfig = Object.assign(appConfigData['zxwy-pub'][process.env.NODE_ENV], appConfigData['zxwy-pub'])

if (process.env.VUE_APP_BASE_API) appConfig['VUE_APP_BASE_API'] = process.env.VUE_APP_BASE_API
if (process.env.VUE_APP_BASE_API_URL) appConfig['VUE_APP_BASE_API_URL'] = process.env.VUE_APP_BASE_API_URL
if (process.env.VUE_APP_WS_BASE_API) appConfig['WS_BASE_API'] = process.env.VUE_APP_WS_BASE_API

export const appList = appConfigData.appList.map(app => Object.assign(app[process.env.NODE_ENV], app))

export const appEnum = Object.fromEntries(Object.keys(appConfigData)
  .filter((key) => validate(appConfigData[key], 'Object'))
  .map((key) => {
    const app = appConfigData[key]

    return [key, Object.assign(app[process.env.NODE_ENV], app)]
  }))
